import { useIntl } from "react-intl";
import { TITLE_APPEND } from "../config/constants";
import { IntlMessageId, UnprefixedKeys } from "../assets/localization/types";
import { prefixes } from "../assets/localization/utils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TemplateValues = Record<string, any> | null;

export type FormatMsg = (
  intlId: IntlMessageId,
  values?: TemplateValues,
  concat?: string
) => string;

export const useFormatMsg = (): FormatMsg => {
  const { formatMessage } = useIntl();
  const formatMsg: FormatMsg = (intlId, values, concat = "") => {
    const translatedMsg = formatMessage({ id: intlId }, values ?? undefined);
    return translatedMsg.concat(concat);
  };
  return formatMsg;
};

export const useFormattedMsg: FormatMsg = (...params) => {
  const formatMsg = useFormatMsg();
  return formatMsg(...params);
};

type UsePageTitle = <S extends string>(
  intlIdSuffix: UnprefixedKeys["PageTitle"],
  values?: TemplateValues
) => string;
export const usePageTitle: UsePageTitle = (intlIdSuffix, values = null) => {
  const intlId = `${prefixes.pageTitle}.${intlIdSuffix}` as const;
  return useFormattedMsg(intlId, values, TITLE_APPEND);
};
